import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import { all_status } from "./consts";
import SingleStatus from "./SingleStatus";
import { DropdownWrapper } from "./style";

// eslint-disable-next-line react/display-name
var StatusDropdown = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    collapsed = _ref.collapsed,
    onSelect = _ref.onSelect,
    options = _ref.options;
  return /*#__PURE__*/React.createElement(DropdownWrapper, {
    collapsed: collapsed,
    ref: ref,
    className: className
  }, (options || all_status).map(function (status_name) {
    return /*#__PURE__*/React.createElement(SingleStatus, {
      key: status_name,
      status: status_name,
      onClick: function onClick() {
        return onSelect(status_name);
      },
      className: "single-status"
    });
  }));
});
StatusDropdown.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  onSelect: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.string)
};
export default StatusDropdown;